import React, {
    useContext,
    useState,
} from 'react';
import { useQuery } from '@tanstack/react-query';


import config from "../config/config";
import * as QUERIES from "../queries/query-functions";

import BasketTicketItem from './basket-ticket-item';
import LoadingIndicator from '../components/loading-indicator';

export default function BasketEvent (props) {

    const { 
        isPending,
        isFetching,
        data: imageData,
    } = useQuery({
        queryKey: ['imageData', props.event.event_id],
        queryFn: () => QUERIES.getEventImage(props.event.event_id),
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: 86400000
    });

    return (
        <div className='basket-item'>
            {!!!props.isSupplementaryView &&
                <>
                    <div className='basket-item__image'> 
                        {isPending || isFetching ?
                            <LoadingIndicator />
                        : imageData ?
                            <div className='basket-item__image--wp' dangerouslySetInnerHTML={{__html: imageData}}></div>
                        : props.event.event_image ?
                            <img src={props.event.event_image } className='basket-item__image--spektrix' />
                        : props.event.event_venue && config.LOGO_URLS[props.event.event_venue] ?
                            <img src={config.LOGO_URLS[props.event.event_venue]} className={`basket-item__image--logo ${props.event.event_venue}`} />
                        : config.LOGO_URLS?.site ?
                            <img src={config.LOGO_URLS?.site} className='basket-item__image--logo' />
                        : null
                        }
                    </div>
                    <div className='basket-item__summary'>
                        <h2 className='basket-item__title'>{props.event.event_name}</h2>
                        <p className='basket-item__date'>{props.event.instance_date}</p>
                        {props.event.event_venue && <p className='basket-item__venue'>{props.event.event_venue}</p>}
                    </div>
                </>
            }
            <ul className='basket-item__ticket-list' role="list">
                {
                !!!props.isSupplementaryView ?
                    props.event.tickets?.map((ticket) => (
                        <BasketTicketItem key={ticket.id} ticket={ticket} />
                    ))
                    :
                    props.event.map((event) => (
                        <BasketTicketItem 
                            eventName={event.event_name.toLowerCase().includes("refund") ? 'Ticket protection' : event.event_name} 
                            isSupplementaryView
                            key={event.event_id} 
                            ticket={event.tickets[0]}
                            sublingSupplementary={event.tickets.map(ticket => ticket.id)} />
                    ))
                    // : <BasketTicketItem 
                    //     eventName={props.event.event_name.toLowerCase().includes("refund") ? 'Ticket protection' : props.event.event_name} 
                    //     key={props.event.tickets[0].id} ticket={props.event.tickets[0]} amount={props.event.tickets.length} 
                    //     isSupplementaryView/>
                }
            </ul>
        </div>
    )
}